(function () {
  if (window.shirtCalculatorLoaded) return;
  window.shirtCalculatorLoaded = true;

  function popupEnabled() {
    return window.shirtCalculatorPopupEnabled !== false;
  }

  function initCalculator(root) {
    if (!root || root.dataset.calculatorInitialized === 'true') return;

    var wearInput = root.querySelector('[data-wear]');
    var bufferInput = root.querySelector('[data-buffer]');
    var laundryOptions = root.querySelectorAll('[data-laundry]');
    var shopLink = root.querySelector('[data-shop-link]');

    if (!wearInput || !bufferInput || !shopLink) return;

    root.dataset.calculatorInitialized = 'true';

    var singlePrice = parseFloat(root.dataset.singlePrice) || 45;
    var packQuantity = parseInt(root.dataset.packQuantity, 10) || 3;
    var packTotal = parseFloat(root.dataset.packTotalPrice) || 110;
    var packUnitPrice = packTotal / packQuantity;
    var baseShopUrl = shopLink.getAttribute('href');
    var state = { wear: 5, laundry: 7, buffer: 2 };

    function setText(selector, value) {
      var element = root.querySelector(selector);
      if (element) element.textContent = value;
    }

    function formatMoney(value) {
      return '$' + value.toFixed(2);
    }

    function calculate() {
      var laundryDayShirt = state.wear === 7 ? 1 : 0;
      var inRotation = Math.ceil((state.wear / 7) * state.laundry) + laundryDayShirt;
      var total = inRotation + state.buffer;
      var unitPrice;
      var totalPrice;
      var savingsLabel;

      if (total >= packQuantity) {
        unitPrice = packUnitPrice;
        totalPrice = total * packUnitPrice;
        var saved = (total * singlePrice) - totalPrice;
        savingsLabel = 'Save $' + saved.toFixed(0) + ' — ' + packQuantity + ' for $' + packTotal + ', always';
      } else {
        unitPrice = singlePrice;
        totalPrice = total * singlePrice;
        var remaining = packQuantity - total;
        savingsLabel = 'Add ' + remaining + ' more for ' + packQuantity + ' for $' + packTotal;
      }

      setText('[data-wear-value]', state.wear);
      setText('[data-buffer-value]', state.buffer);
      setText('[data-total]', total);
      setText('[data-rotation]', inRotation);
      setText('[data-laundry-display]', state.laundry);
      setText('[data-buffer-display]', state.buffer);
      setText('[data-qty-label]', total + (total === 1 ? ' shirt × ' : ' shirts × ') + formatMoney(unitPrice));
      setText('[data-total-price]', formatMoney(totalPrice));
      setText('[data-savings]', savingsLabel);
      setText('[data-cta-text]', 'Shop ' + total + (total === 1 ? ' white shirt' : ' white shirts'));

      if (baseShopUrl) {
        shopLink.href = baseShopUrl + (baseShopUrl.indexOf('?') > -1 ? '&' : '?') + 'need=' + total;
      }
    }

    wearInput.addEventListener('input', function (event) {
      state.wear = parseInt(event.target.value, 10);
      calculate();
    });

    bufferInput.addEventListener('input', function (event) {
      state.buffer = parseInt(event.target.value, 10);
      calculate();
    });

    laundryOptions.forEach(function (button) {
      button.addEventListener('click', function () {
        laundryOptions.forEach(function (option) {
          option.classList.remove('active');
        });
        button.classList.add('active');
        state.laundry = parseInt(button.dataset.laundry, 10);
        calculate();
      });
    });

    calculate();
  }

  function initAllCalculators(container) {
    var scope = container || document;
    scope.querySelectorAll('[data-shirt-calculator]').forEach(initCalculator);
    scope.querySelectorAll('[data-shirt-calculator-dialog]').forEach(initDialog);
    scope.querySelectorAll('[data-shirt-calculator-popup]').forEach(function (callout) {
      callout.hidden = !popupEnabled();
    });
  }

  function initDialog(dialog) {
    if (dialog.dataset.dialogInitialized === 'true') return;
    dialog.dataset.dialogInitialized = 'true';

    var lastTrigger = null;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-shirt-calculator-open]');
      if (!popupEnabled() || !trigger || trigger.getAttribute('aria-controls') !== dialog.id) return;

      lastTrigger = trigger;
      if (!dialog.open) dialog.showModal();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-shirt-calculator-close]')) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', function () {
      if (lastTrigger) lastTrigger.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCalculators(document);
    });
  } else {
    initAllCalculators(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllCalculators(event.target);
  });
})();
